import { defineContent, type DefinedContent } from '@post-office/define-content';

export const registeredContent: DefinedContent<['header', 'cta', 'reasonsModalMessage']> =
	defineContent({
		default: {
			header: {
				id: 'growth.recommendation-jsm.product-name.header',
				description: 'Header for Jira Service Management recommendation message in Jira Side Nav',
				defaultMessage: 'Automate workflows for faster resolutions',
				role: 'title',
			},
			cta: {
				id: 'growth.recommendation-jsm.cta.label',
				description: 'CTA text for Jira Service Management recommendation message in Jira Side Nav',
				defaultMessage: 'Try Jira Service Management',
			},
			reasonsModalMessage: {
				id: 'growth.recommendation-jsm.reasons-modal.message',
				defaultMessage:
					"We think {jsm} will improve your team's productivity. The recommendation is based on:",
				description:
					'Explanation of why we think the JSM recommendation will be relevant to the customer.',
				role: 'description',
			},
		},
	});
